import React from 'react';
import { FIXTURE_SYMBOLS, type FixtureSymbolKey } from '@/lib/fixtureSymbols';

interface Props { symbolKey: FixtureSymbolKey; rotationDeg?: number; className?: string }

// Rendert ein Fixture-Symbol als S/W-SVG (Palette + Rnd-Preview). Stretch-to-fill (nicht
// Seitenverhältnis-erhaltend) mit voller weißer Box-Füllung, damit die Vorschau dem
// Canvas-Burn-in (fixtureSymbolRender.ts) entspricht.
export const FixtureSymbolSvg: React.FC<Props> = ({ symbolKey, rotationDeg = 0, className }) => {
  const sym = FIXTURE_SYMBOLS[symbolKey];
  if (!sym) return null;
  const vb = sym.viewBox.trim().split(/\s+/).map(Number);
  const [minX, minY, width, height] = vb;
  return (
    <svg viewBox={sym.viewBox} className={className} preserveAspectRatio="none"
         style={{ width: '100%', height: '100%', transform: `rotate(${rotationDeg}deg)` }}
         fill="none" stroke="#111" strokeWidth={2} strokeLinejoin="round" strokeLinecap="round">
      <rect x={minX} y={minY} width={width} height={height} fill="#fff" stroke="none" />
      {sym.elements.map((el, i) =>
        el.type === 'path' ? <path key={i} d={el.d} />
        : el.type === 'rect' ? <rect key={i} x={el.x} y={el.y} width={el.width} height={el.height} rx={el.rx} ry={el.ry} />
        : <circle key={i} cx={el.cx} cy={el.cy} r={el.r} />,
      )}
    </svg>
  );
};
